var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrid2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.999,
    height: 40.002,
    viewBox: "0 0 89.999 40.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Soustraction_2",
    "data-name": "Soustraction 2",
    transform: "translate(4103 5138)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -4014.00048828125 -5098.99951171875 L -4055 -5098.99951171875 L -4055 -5137.00048828125 L -4014.00048828125 -5137.00048828125 L -4014.00048828125 -5098.99951171875 Z M -4061 -5098.99951171875 L -4101.99951171875 -5098.99951171875 L -4101.99951171875 -5137.00048828125 L -4061 -5137.00048828125 L -4061 -5098.99951171875 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -4015.00048828125 -5099.99951171875 L -4015.00048828125 -5136.00048828125 L -4054 -5136.00048828125 L -4054 -5099.99951171875 L -4015.00048828125 -5099.99951171875 M -4062 -5099.99951171875 L -4062 -5136.00048828125 L -4100.99951171875 -5136.00048828125 L -4100.99951171875 -5099.99951171875 L -4062 -5099.99951171875 M -4013.00048828125 -5097.99853515625 L -4013.00048828125 -5097.99951171875 L -4056 -5097.99951171875 L -4056 -5138.00048828125 L -4013.00048828125 -5138.00048828125 L -4013.00048828125 -5097.99853515625 Z M -4060 -5097.99853515625 L -4060 -5097.99951171875 L -4102.99951171875 -5097.99951171875 L -4102.99951171875 -5138.00048828125 L -4060 -5138.00048828125 L -4060 -5097.99853515625 Z",
    stroke: "none",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid2);
export default __webpack_public_path__ + "static/media/grid2.dda81b93970b7b2902c81325221b4cc1.svg";
export { ForwardRef as ReactComponent };